/**
 * Configuration file for OpenSports group aliases
 * Add new groups by including their alias ID from their OpenSports URL
 */
export const groupConfig = {
  groups: [
    {
      id: 'brisbane-pickleball-club',
      name: 'Brisbane Pickleball Club'
    },
    {
      id: 'picklehub',
      name: 'PickleHub'
    },
    {
      id: 'pickle-kit',
      name: 'Pickle Kit'
    },
    {
      id: 'bbpc',
      name: 'Brisbane Bayside Pickleball Club'
    },
    {
      id: 'brisbane-pickleball-academy',
      name: 'Brisbane Pickleball Academy'
    },
    {
      id: 'thepickleballhive',
      name: 'The Pickleball Hive'
    },
    {
      id: 'kt-academy-pickleball-mooloolaba',
      name: 'KT Academy Pickleball Mooloolaba'
    },
    {
      id: 'focus-pickleball-redcliffe',
      name: 'Focus Pickleball Redcliffe'
    },
    {
      id: 'moreton-city-pickleball',
      name: 'Moreton City Pickleball'
    },
    {
      id: 'redlands-pickleball-club',
      name: 'Redlands Pickleball Club'
    },
    {
      id: 'matchpoint-tennis-and-pickleball',
      name: 'Matchpoint Tennis and Pickleball'
    }
  ]
};
